/* unplugin-vue-components disabled */var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "top",
      attrs: { dark: "", flat: "", tile: "", color: _vm.color },
    },
    [
      _c("div", { staticClass: "top-header" }, [
        _c(
          "div",
          { staticClass: "top-content" },
          [
            _c(
              "v-row",
              {
                staticClass: "fill-height px-6 py-3 text-center",
                attrs: { dense: "", align: "center", justify: "center" },
              },
              [_c("v-col", [_vm._t("default")], 2)],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "top-onda" }, [
        _c(
          "svg",
          { staticClass: "top-onda-svg", attrs: { viewBox: "0 0 1920 79" } },
          [
            _c("path", {
              style: "fill: " + _vm.fill,
              attrs: {
                d: "M0 59l64-11c64-11 192-34 320-43s256-5 384 4 256 23 384 34 256 21 384 14 256-30 320-41l64-11v94H0z",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }